<script>
  import { createEventDispatcher, tick } from 'svelte';
  import Select from 'svelte-select';
  import { listConfigs, createConfig } from '../api';
  let runList = listConfigs();
  let newClientId = null;
  const getOptionLabel = (option) => option.client_name + ' , ' + option.cid;
  const dispatch = createEventDispatcher();

  const editItem = (payload) => {
    dispatch('editItem', payload.detail);
  };
  const createNew = async () => {
    if (newClientId == null) return;
    await createConfig(newClientId);
    await tick();
    runList = listConfigs();
  };

  const clearItem = () => {
    dispatch('editItem', null);
  };
</script>

<header>
  <h1>Configs</h1>

  <div>
    <input type="text" bind:value={newClientId} placeholder="Client ID" />
    <button class="primary" on:click={createNew}>Create new config</button>
  </div>
</header>
<div class="grid-list-wrapper">
  {#await runList then clients}
    {#if Array.isArray(clients)}
      <Select items={clients} {getOptionLabel} on:select={editItem} on:clear={clearItem} placeholder={'Select a client to edit'} />
    {:else}
      <p>No configs found</p>
    {/if}
  {/await}
</div>
